<template>
  <div class="RadioImageComponent">
    <div v-if=" label == 'Coming soon'|| label == 'Binnenkort'">
      <label class="outsideLable" disabled>
        <input type="radio" disabled name="radioButton">
        <img class="imageButtonsDisabled" :src="image">
        <label class="insideLables">{{ label }}</label>
      </label>
    </div>
    <div v-else>
      <label class="outsideLable">
        <input
          type="radio"
          :value="value"
          @change="$emit('update:modelValue', value)"
          name="radioButton"
        >
        <img class="imageButtons" :src="image">
        <label class="insideLables">{{ label }}</label>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioImageComponent",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    picture: {
      type: String,
      default: ""
    }
  },

  computed: {
    image() {
      return `https://phoenix-engineering-images.ams3.digitaloceanspaces.com/${
        this.picture
      }`;
    }
  }
};
</script>


<style scoped>
.RadioImageComponent {
  display: inline-block;
  margin: 40px;
  margin-bottom: 40px;
  margin-top: 20px;
  vertical-align: top;
}

input {
  display: block;
  margin-bottom: 10px;
}

.insideLables {
  letter-spacing: 1.5px;
  font-family: "Raleway", sans-serif;
  overflow-wrap: break-word;
  display: block;
  width: 130px;
  font-size: 15px;
  padding-top: 6px;
  margin-left: 2px;
}

.imageButtons {
  opacity: 0.6;
  width: 100px;
  height: 135px;
  border: 2px rgb(41, 41, 42) solid;
  box-shadow: 0 0px 5px 0px rgb(89, 102, 100);
}

.imageButtonsDisabled {
  opacity: 0.1;
  width: 100px;
  height: 135px;
  cursor: not-allowed;
  border: 2px rgb(41, 41, 42) solid;
  box-shadow: 0 0px 5px 0px rgb(89, 102, 100);
  cursor: not-allowed !important;
}

.imageButtons:hover {
  opacity: 1;
}

.RadioImageComponent:hover {
  transform: scale(1.02);
  opacity: 1;
}

/*-----------------------------------------------------------------------Make a radio button appear as an image-------------------------------------------------------------------------*/

[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* IMAGE STYLES */
[type="radio"] + img {
  cursor: pointer;
}

/* CHECKED STYLES */
[type="radio"]:checked + img {
  opacity: 1;
}

@media screen and (max-width: 1200px) {
  .RadioImageComponent {
    display: inline-block;
    margin: 30px;
  }

  .imageButtons {
    opacity: 0.8;
    width: 90px;
    height: 120px;
  }

  .imageButtonsDisabled {
    width: 90px;
    height: 120px;
  }
  .insideLables {
    font-size: 13px;
  }
}
@media screen and (max-width: 950px) {
  .RadioImageComponent {
    display: inline-block;
    margin: 20px;
  }
}
@media screen and (max-width: 400px) {
  .RadioImageComponent {
    margin: 10px;
    margin-bottom: 20px;
  }
}
</style>